// @flow

const transitionTimingFunction = 'ease-in-out';
const transitionDuration = '300ms';
const transitionValue = `all ${transitionDuration} ${transitionTimingFunction}`;

export default {
  transitionTimingFunction,
  transitionDuration,
  transitionValue,
};
